import { Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs'
import { SafePipe } from 'safe-pipe';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-vehicle-specification',
  templateUrl: './vehicle-specification.component.html',
  styleUrls: ['./vehicle-specification.component.scss']
})
export class VehicleSpecificationComponent implements OnInit,OnChanges {
  sub: Subscription = new Subscription
  vehicleDetail: any = "";
  productId: any;

  environment1 = environment.s3bucket.url;
  @Input() vehicleSpecification: any;
  @Input() specificationList:any;
  productLoaded:boolean = false;
  specificationImg:SafeHtml;
  private safePipe1: SafePipe = new SafePipe(this.domSanitizer);
  constructor( private domSanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: Object,
    private cleverService: ClevertapService,) { }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Vehicle Specification");
      } catch { }
    }
    this.vehicleDetail = this.vehicleSpecification.data
  }

  getUrl(lob,ppl) {
    if (ppl && ppl !== 'undefined') {
      let imageData: any = this.specificationList.filter((value: any) => {
        if (value.actual_ppl == ppl) {
          return value;
        }
      });

      if (imageData?.length > 0) {
        this.specificationImg = imageData[0]?.img
        return this.safePipe1.transform(imageData[0]?.img,'url');
      }
      else {
        if (lob && lob !== 'undefined') {
          let imageDataLob: any = this.specificationList.filter((value: any) => {
            if (value.actual_lob == lob) {
              return value;
            }
          });
          if (imageDataLob?.length > 0) {
            this.specificationImg = imageDataLob[0]?.img
            return this.safePipe1.transform(imageDataLob[0]?.img,'url');
          }
        }

    }
    }
    this.productLoaded = true
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['vehicleSpecification'] && !changes['vehicleSpecification'].firstChange) {
      const newSpecification = changes['vehicleSpecification'].currentValue;
      this.vehicleDetail=newSpecification.data
    }
  }
}
